import { render, staticRenderFns } from "./TotalItem.vue?vue&type=template&id=48f41bf6&"
import script from "./TotalItem.vue?vue&type=script&lang=js&"
export * from "./TotalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports